import { render, staticRenderFns } from "./couponGoodsList.vue?vue&type=template&id=fa42ecf4&scoped=true&"
import script from "./couponGoodsList.vue?vue&type=script&lang=js&"
export * from "./couponGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./couponGoodsList.vue?vue&type=style&index=0&id=fa42ecf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa42ecf4",
  null
  
)

export default component.exports